// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".deployedInfoText___x5b4E{font-size:14px;line-height:24px;color:var(--gray600)}\n", "",{"version":3,"sources":["webpack://./src/components/DeployedInfoText/DeployedInfoText.css"],"names":[],"mappings":"AAAA,0BACI,cAAA,CACA,gBAAA,CACA,oBAAA","sourcesContent":[".deployedInfoText {\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--gray600);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deployedInfoText": "deployedInfoText___x5b4E"
};
export default ___CSS_LOADER_EXPORT___;
